var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pre-login-layout',{scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('router-view')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }